
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make-offer/[[...page]]",
      function () {
        return require("private-next-pages/make-offer/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make-offer/[[...page]]"])
      });
    }
  